export default {
  trackingAnalyics: process.env.trackingAnalyics,
  shipbobV2Api: process.env.shipbobV2Api,
  authenticate: process.env.authenticate,
  refresh: process.env.refresh,
  ordersapi: process.env.ordersapi,
  controlPlaneApi: process.env.controlplaneapi,
  frontEndAppSettings: process.env.frontEndAppSettings,
  exporterApi: process.env.exporterApi,
  orderActionApi: process.env.orderActionApi,
  tracking: process.env.tracking,
  recaptchaSiteKey: process.env.recaptchaSiteKey,
  Intercom: {
    app_id: process.env['Intercom.app_id'],
    messenger_attributes: {
      hide_default_launcher: process.env['Intercom.messenger_attributes.hide_default_launcher']
    }
  },
  ApplicationInsights: {
    ConnectionString: process.env['ApplicationInsights.ConnectionString']
  },
  whitelabelCDNSource: process.env.whitelabelCDNSource,
  customersApi: process.env.customersApi,
  productsApi: process.env.productsApi,
  publicProductsApi: process.env.publicProductsApi,
  analyticsApi: process.env.analyticsApi,
  analyticsApiPoc: process.env.analyticsApiPoc,
  integrationsApi: process.env.integrationsApi,
  dashboardPath: process.env.dashboardPath,
  photoPrint: process.env.photoPrint,
  analyticsDashboardUrl: process.env.analyticsDashboardUrl,
  merchantAppImageAssetPath: process.env.merchantAppImageAssetPath,
  vueRouterBase: process.env.vueRouterBase,
  vueRouterB2BBase: process.env.vueRouterB2BBase,
  receivingApi: process.env.receivingApi,
  wmsApi: process.env.wmsApi,
  merchantApi: process.env.merchantApi,
  fulfillmentApi: process.env.fulfillmentApi,
  publicOrdersApi: process.env.publicOrdersApi,
  claimsFunction: process.env.claimsFunction,
  ordersStateApi: process.env.ordersStateApi,
  cdn: process.env.cdn,
  addressValidator: process.env.addressValidator,
  addressValidatorApiKey: process.env.addressValidatorApiKey,
  labelingApi: process.env.labelingApi,
  shipmentTrackingApiURL: process.env.shipmentTrackingApiURL,
  ShippingServiceApiUrl: process.env.ShippingServiceApiUrl,
  publicInventoryApi: process.env.publicInventoryApi,
  receivingPublicApi: process.env.receivingPublicApi,
  pandiumBaseUrl: process.env.pandiumBaseUrl,
  returnsApi: process.env.returnsApi,
  recaptchaSuppressEmailRegexMatch: process.env.recaptchaSuppressEmailRegexMatch,
  locationsApi: process.env.locationsApi,
  powerBIConfigGeneratorUrl: process.env.powerBIConfigGeneratorUrl,
  ShipBobPublicLocationsApiBaseUrl: process.env.ShipBobPublicLocationsApiBaseUrl,
  WorkOrderApiBaseUrl: process.env.WorkOrderApiBaseUrl,
  FulfillmentCustomizationApiUrl: process.env.FulfillmentCustomizationApiUrl,
  PendoSchuduleUpdateTime: process.env.PendoSchuduleUpdateTime,
  PackingSlipBaseUrl: process.env.PackingSlipBaseUrl,
  inventoryAllocationApi: process.env.inventoryAllocationApi,
  inboundManagementApi: process.env.inboundManagementApi,
  inventoryDistributionApiUrl: process.env.inventoryDistributionApiUrl,
  AppSettings: {
    AttachmentEndpoint: process.env['AppSettings.AttachmentEndpoint'],
    PackageSelectionBaseUrl:
      process.env['AppSettings.PackageSelectionBaseUrl']
  },
  SalesforceConfig: {
    FCRequestAccessFormUrl:
      process.env['SalesforceConfig.FCRequestAccessFormUrl']
  },
  MerchantPricingApi: {
    ApiBaseUrl: process.env['MerchantPricingApi.ApiBaseUrl']
  },
  PaymentApi: {
    ApiBaseUrl: process.env['PaymentApi.ApiBaseUrl']
  },
  CartBobApi: {
    ApiBaseUrl: process.env['CartBobApi.ApiBaseUrl']
  },
  Pandium: {
    ShopifyIntegrationId: process.env['Pandium.ShopifyIntegrationId'],
    CartBobIntegrationId: process.env['Pandium.CartBobIntegrationId']
  },
  shopifyInstallUrl: process.env.shopifyInstallUrl,
  userManApi: process.env.userManApi,
  membershipApi: process.env.membershipApi,
  userAccountsApi: process.env.userAccountsApi,
  onboardingApi: process.env.onboardingApi,
  OnboardingDashboardConfig: {
    OfficeHoursLink: process.env['OnboardingDashboardConfig.OfficeHoursLink'],
    HelpCenterLink: process.env['OnboardingDashboardConfig.HelpCenterLink']
  },
  OnboardingWizard: {
    BdrGrowthUtmSource: process.env['OnboardingWizard.BdrGrowthUtmSource'],
    BdrGrowthDefaultShipmentsPerMonth: process.env['OnboardingWizard.BdrGrowthDefaultShipmentsPerMonth'],
    HideCostCalculatorMinShipmentsPerMonth: process.env['OnboardingWizard.HideCostCalculatorMinShipmentsPerMonth'],
    ShipOptionId: process.env['OnboardingWizard.ShipOptionId'],
    MinPricingZoneId: process.env['OnboardingWizard.MinPricingZoneId'],
    MaxPricingZoneId: process.env['OnboardingWizard.MaxPricingZoneId']
  },
  SignUpPageSettings: {
    enableIFrame: process.env['SignUpPageSettings.enableIFrame'],
    iFrameDomain: process.env['SignUpPageSettings.iFrameDomain'],
    iFramePage: process.env['SignUpPageSettings.iFramePage'],
    ConfirmEmailRequired: process.env['SignUpPageSettings.ConfirmEmailRequired']
  },
  wroDangerousGoodsListHref: process.env.wroDangerousGoodsListHref,
  productsManagementApi: process.env.productsManagementApi,
  analyticsTicketsUrl: process.env.analyticsTicketsUrl,
  ipsTicketUrl: process.env.ipsTicketUrl,
  authUri: process.env.authUri,
  authClient: process.env.authClient,
  authScopes: process.env.authScopes,
  DecagonChatBotUrl: process.env.DecagonChatBotUrl,
  paragonAuthenticationApiUrl: process.env.paragonAuthenticationApiUrl,
  KYC: {
    environmentId: process.env['KYC.environmentId']
  },
  productV2Route: process.env.photoPrint + '/App/IndexV2/#/productV2Route'
}
